export const ACTION_TABS_PATH = 'ACTION_TABS_PATH';
export const ACTION_TABS_PATH_RESET = 'ACTION_TABS_PATH_RESET';
export const ACTION_TABS_UNLOCK_ALL = 'ACTION_TABS_UNLOCK_ALL';

export function actionTabs(path: string) {
  return { type: ACTION_TABS_PATH, payload: { path } };
}

export function actionTabsReset() {
  return { type: ACTION_TABS_PATH_RESET };
}

/**
 * Desbloquea todas las tabs de una vez.
 * Usar en flujo de VALIDACIÓN donde la acción ya existe con todos los datos.
 */
export function actionTabsUnlockAll() {
  return { type: ACTION_TABS_UNLOCK_ALL };
}
